import axios from "axios";
import { HttpClient } from "react-http-client";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import Config from "../_config/config";
import { User } from "../_models";

class AuthenticationService {
  public BASE_URL = Config.baseUrl;
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor() {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    return this.currentUserSubject.value;
  }
  public setCurrentUserValue(data: any): void {
    console.log(this.currentUserSubject);
    this.currentUserSubject.next(data);
    console.log(this.currentUserSubject);
  }

  login(username: string, password: string) {
    let credentials = {
      userName: username,
      password: password,
      deviceId: this.getDeviceId(),
    };
    //let url = `${this.BASE_URL}rest/mobile/iteach/authenticate/user`;
    let url = "";
    console.log("Config.authBackend:", Config.authBackend);
    console.log("Config.authBaseUrl:", Config.authBaseUrl);
    url = Config.authBaseUrl + "rest/mobile/iteach/authenticate/user";
    console.log("Authentication URL:", url);
    return axios.post<any>(url, credentials);
  }

    loginUserWithToken = (token: string)=>{
     let credentials = {
      token,
      deviceId: this.getDeviceId(),
    };
    //let url = `${this.BASE_URL}rest/mobile/iteach/authenticate/user`;

    const url = `${Config.authBaseUrl}rest/mobile/iteach/authenticate/user`;
    console.log("Token Authentication URL:", url);
    return axios.post<any>(url, credentials);
  }

  getDeviceId(): string {
    if (!localStorage.getItem("iteach-pwa-deviceId")) {
      console.log("DeviceId Not found generating new");
      let sixdigitsrandom = Math.floor(100000 + Math.random() * 900000);
      localStorage.setItem("iteach-pwa-deviceId", "PWA-" + sixdigitsrandom);
    }
    return localStorage.getItem("iteach-pwa-deviceId");
  }

  /*login(username, password) {
        return this.http.post<any>(`http://localhost:4200/users/authenticate`, { username, password })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }));
    }*/

  recoverPassword(username: string) {
    return axios.post<any>(`${Config.nodeSiteUrl}v1/password/recover`, {
      userName: username,
    });
  }

  resetPassword(
    username: string,
    otp: string,
    newPassword: string,
    confirmPassword: string
  ) {
    return axios.post<any>(`${Config.nodeSiteUrl}v1/password/reset`, {
      userName: username,
      otp,
      newPassword,
      confirmPassword,
    });
  }

  logout() {
    // remove user from local storage and set current user to null
    localStorage.removeItem("currentUser");
    this.currentUserSubject.next(null);
  }
}

export default new AuthenticationService();
